var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/components/JoinTeamCTA/index.tsx",
  _this = this;
import { T, defineMessages } from '@sm/intl';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { createURL } from '@sm/utils';
import { Button } from '@wds/button';
import React from 'react';
var COPY = defineMessages({
  JOIN_TEAM: {
    id: 'JoinTeamCTA.JoinTeam',
    defaultMessage: 'Join team',
    description: '[Type: Label][Vis: High] - Join team button in the header'
  }
});
var JoinTeamCTA = function JoinTeamCTA(_ref) {
  var joinTeamSlug = _ref.joinTeamSlug,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
    _ref$stretched = _ref.stretched,
    stretched = _ref$stretched === void 0 ? false : _ref$stretched,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color;
  var handleClick = function handleClick() {
    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        amplitudeEvent: 'review session landing page clicked join team cta',
        interactionType: 'click'
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: size,
    variant: variant,
    stretched: stretched,
    color: color,
    target: "_blank",
    href: createURL("/request-team-seat/".concat(joinTeamSlug)),
    onClick: handleClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.JOIN_TEAM,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 9
    }
  })));
};
export default JoinTeamCTA;
//# sourceMappingURL=index.js.map